export default "__VITE_ASSET__pRaowCph__"